import { render, staticRenderFns } from "./CopySettings.vue?vue&type=template&id=53132035&scoped=true"
import script from "./CopySettings.vue?vue&type=script&lang=js"
export * from "./CopySettings.vue?vue&type=script&lang=js"
import style0 from "./CopySettings.vue?vue&type=style&index=0&id=53132035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53132035",
  null
  
)

export default component.exports